var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 113,
    viewBox: "0 0 113 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 56.5,
    r: 56.5,
    fill: "#FFCACA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.6889 52.8657L56.1047 58.4498L50.4942 52.8657L46.7803 56.5797L52.3907 62.1638L46.8066 67.748L50.5206 71.4619L56.1047 65.8778L61.6889 71.4619L65.4029 67.748L59.8187 62.1638L65.4029 56.5797L61.6889 52.8657ZM65.3238 35.8235L62.6898 33.1895H49.5197L46.8856 35.8235H37.6665V41.0916H74.543V35.8235H65.3238ZM40.3005 75.334C40.3005 78.2314 42.6712 80.602 45.5686 80.602H66.6409C69.5383 80.602 71.9089 78.2314 71.9089 75.334V43.7256H40.3005V75.334ZM45.5686 48.9936H66.6409V75.334H45.5686V48.9936Z",
    fill: "#BF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.d2a76a221d138acb3b129f36d0d0a904.svg";
export { ForwardRef as ReactComponent };